import {
  AccountApi,
  AnalyticsApi,
  AuthApi,
  BonusesApi,
  BonusHistoryApi,
  Configuration,
  InfoApi,
  LiveApi,
  RewardsApi,
  TransactionsApi,
  UserPoolApi,
} from 'restApi/openapi'

export * from 'restApi/openapi/runtime'
export * from 'restApi/openapi/apis'
export * from 'restApi/openapi/models'

const bindMethodsToInstance = (instance) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(instance))
    .filter((methodName) => typeof instance[methodName] === 'function' && methodName !== 'constructor')
    // eslint-disable-next-line no-return-assign, no-param-reassign
    .forEach((methodName) => (instance[methodName] = instance[methodName].bind(instance)))

  return instance
}

const config = new Configuration({ basePath: '' })

export const accountApi = bindMethodsToInstance(new AccountApi(config))
export const analyticsApi = bindMethodsToInstance(new AnalyticsApi(config))
export const authApi = bindMethodsToInstance(new AuthApi(config))
export const bonusesApi = bindMethodsToInstance(new BonusesApi(config))
export const bonusHistoryApi = bindMethodsToInstance(new BonusHistoryApi(config))
export const infoApi = bindMethodsToInstance(new InfoApi(config))
export const liveApi = bindMethodsToInstance(new LiveApi(config))
export const rewardsApi = bindMethodsToInstance(new RewardsApi(config))
export const transactionsApi = bindMethodsToInstance(new TransactionsApi(config))
export const userPoolApi = bindMethodsToInstance(new UserPoolApi(config))
